import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import styles from '../../MenuItem.module.scss';
import { UserTypes } from '../../../../domains/user/user-types';

import { ReactComponent as CalendarIcon } from '../../../../assets/icons/icon_calendar.svg';

const CalendarButton = ({ handleMenuLinkClick, user }) => {
  if (user?.user_type !== UserTypes.tutor) return;

  return (
    <li className={styles['link-wrapper']} data-testid="calendar-button">
      <NavLink
        to="/calendar"
        onClick={() => handleMenuLinkClick('calendar')}
        activeClassName={styles.isActive}
        className={styles.menuItem}
        data-testid="calendar-link">
        <div className={styles['button-wrapper']}>
          <div className={styles['background']}>
            <CalendarIcon />
          </div>
          <span>Calendar</span>
        </div>
      </NavLink>
    </li>
  );
};

CalendarButton.propTypes = {
  handleMenuLinkClick: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
};

export default CalendarButton;
